var render = function render(){var _vm=this,_c=_vm._self._c;return _c('topo',{scopedSlots:_vm._u([{key:"botoes",fn:function(){return [_c('documentos')]},proxy:true},{key:"usuario",fn:function(){return [_c('usuario')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }